<section id="marital-stat-maint">    
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <!-- Container for Marital Status Table using prime ng -->
        <div class = 'table-user'>
            <osp-table [tblConfig]="maritalStatTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="marital-stat-maintenance-loading">
            <div class="form-loader"></div>
        </div>
        <div class="form-content" *ngIf="showForm">
            <form [formGroup]="forms.maritalStatForm" class="form">
                <div id="marital-stat-error-message"></div>
                <div class="form-container-grid">
                    <div class="field">
                        <label>Marital Status Code</label>
                    </div>
                    <div class="">
                        <input formControlName="maritalStatCdDisp" type="text" readonly>
                    </div>
                    <div>
                    </div>
                    <div>
                    </div>

                    <div class="field required">
                        <label>Marital Status</label>
                    </div>
                    <div class="">
                        <input formControlName="maritalDesc" type="text" maxlength="20">
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                                {{activeType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>BPIMS Code</label>
                    </div>
                    <div class="">
                        <input formControlName="bmCode" type="text" maxlength="8">
                    </div>
                    <div class="field">
                        <label>BPIMS Short Description</label>
                    </div>
                    <div class="">
                        <input formControlName="bmShortDesc" type="text" maxlength="10">
                    </div>
                    
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text" maxlength="4000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUserUpdate">
                    </div>
                </div>
            </form>
            <div class="btn-row">
                <button *ngIf="btns.maritalStat.updateDisabled" class="btn btn2" type="button" (click)="onAdd()">ADD</button>
                <button *ngIf="!btns.maritalStat.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()">UPDATE</button>
                <button class="btn btn2" type="button" [disabled]='btns.maritalStat.deleteDisabled' (click)="onDelete()"> DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button class="btn btn2" type="button" [disabled]='btns.maritalStat.saveDisabled' (click)="onSave()">SAVE</button>
            </div>
        </div>
    </div>
</section>